import React from "react";

const SuccessPassword = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="bg-black/30 rounded-xl shadow-lg max-w-md w-full p-6 text-center">
        <h2 className="text-xl font-bold mb-2 text-white">Reset Password</h2>
        <p className="text-green-400 font-semibold">
          Your password changed successfully!
        </p>
      </div>
    </div>
  );
};

export default SuccessPassword;
